import { FloatingNode } from '@floating-ui/react'

import { useFloatingTooltip } from '../../../hooks'
import { FloatingTooltipContent } from '../FloatingTooltipContent'
import { FloatingTooltipTrigger } from '../FloatingTooltipTrigger'

function FloatingTooltip({
  children,
  content,
  contentStyles,
  disabled,
  hoverConfig,
  isOpenOnClick,
  markup,
  open,
  placement,
}) {
  const {
    arrowRef,
    context,
    floatingStyles,
    getReferenceProps,
    isOpen,
    nodeId,
    refs,
  } = useFloatingTooltip({
    disabled: !content || disabled,
    hoverConfig,
    isOpenOnClick,
    placement,
  })

  return (
    <>
      <FloatingTooltipTrigger
        context={context}
        getReferenceProps={getReferenceProps}
      >
        {children}
      </FloatingTooltipTrigger>
      <FloatingNode id={nodeId}>
        <FloatingTooltipContent
          arrowRef={arrowRef}
          content={content}
          contentStyles={contentStyles}
          context={context}
          floatingStyles={floatingStyles}
          isOpen={isOpen || open}
          markup={markup}
          refs={refs}
        />
      </FloatingNode>
    </>
  )
}

export default FloatingTooltip
